import React, { useState } from "react";
// import { useLocation } from "react-router-dom";
import "./App.css";
import { store, persistor } from "./redux/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import NetworkStatus from "./pages/common/NetworkStatus";
import AdminRoutes from "./routes/AdminRoutes";
import MerchantRoutes from "./routes/MerchantRoutes";
import FundraiserRoutes from "./routes/FundraiserRoutes";
import UserRoutes from "./routes/UserRoutes";
import CommonRoutes from "./routes/CommonRoutes";
import SessionTimeoutGuard from "./components/common/SessionTimeoutGuard";
// import WebNotifications from "./components/common/WebNotifications";
import { isUserRoute } from "./utils/utilFunctions";

function App() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
//   const location = useLocation();
//   const isGiftCardRoute =
//     location.pathname.startsWith("/gift-card") ||
//     location.pathname === "/gift-cards";
// location.pathname.includes("/gift-card/enter-details");
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <NetworkStatus isOnline={isOnline} setIsOnline={setIsOnline} />
        <SessionTimeoutGuard />
        {/* {!isUserRoute && !isGiftCardRoute && <WebNotifications />} */}
         {!isUserRoute }
         {/* {!isUserRoute && 
  !isGiftCardRoute && 
  typeof window !== "undefined" && 
  "Notification" in window && (
    <WebNotifications />
  )
} */}

        {isOnline && (
          <>
            <CommonRoutes />
            <AdminRoutes />
            <MerchantRoutes />
            <FundraiserRoutes />
            <UserRoutes />
          </>
        )}
      </PersistGate>
    </Provider>
  );
}

export default App;
